module.exports = __webpack_public_path__ + "img/icon_5_3.85c57127.png";